export type GroupKey = "annual" | "monthly" | "trend";

export interface ArticleItem {
  id: string;
  group: GroupKey;
  category: string;
  rank: number;
  title: string;
  excerpt: string;
  date: string;
  month: string;
  heat: string;
  tags: string[];
  cover: string;
  standouts?: string[];
  content: string[];
}

const IMG = {
  hero: "https://readdy.ai/api/search-image?query=A%20bold%20and%20playful%20editorial%20collage%20illustration%20of%20trending%20news%20themes%2C%20colorful%20speech%20bubbles%2C%20magnifying%20glass%2C%20camera%20flashes%20and%20fire%20icons%20floating%20over%20warm%20orange%20and%20cream%20background%2C%20energetic%20pop%20culture%20aesthetic%2C%20flat%20vector%20style%2C%20rich%20texture%2C%20high%20detail%2C%20no%20text%20labels&width=1600&height=900&seq=chigua-hero-x1&orientation=landscape",
  a1: "https://readdy.ai/api/search-image?query=Warm%20orange%20and%20gold%20editorial%20illustration%20of%20a%20giant%20golden%20crown%20and%20trophy%20on%20a%20cream%20stage%20with%20spotlights%20and%20confetti%2C%20flat%20vector%20pop%20style%2C%20playful%20year%20in%20review%20vibe%2C%20soft%20shadows%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a1&orientation=landscape",
  a2: "https://readdy.ai/api/search-image?query=Illustration%20of%20two%20dramatic%20silhouette%20faces%20facing%20off%20with%20lightning%20and%20thunder%20between%20them%20over%20peach%20and%20red%20gradient%20background%2C%20flat%20vector%20editorial%20style%2C%20confrontation%20energy%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a2&orientation=landscape",
  a3: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20phoenix%20rising%20from%20ashes%20with%20warm%20ember%20colors%20of%20orange%20red%20and%20gold%20over%20cream%20background%2C%20comeback%20and%20resilience%20theme%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a3&orientation=landscape",
  a4: "https://readdy.ai/api/search-image?query=Warm%20toned%20flat%20illustration%20of%20office%20workers%20at%20desks%20with%20screens%20showing%20graphs%20and%20megaphones%2C%20business%20and%20corporate%20gossip%20theme%2C%20orange%20amber%20and%20cream%20palette%2C%20modern%20editorial%20vector%20art%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a4&orientation=landscape",
  a5: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20dark%20gaming%20room%20with%20neon%20warm%20lights%20and%20esports%20trophies%2C%20people%20watching%20a%20big%20screen%2C%20orange%20and%20deep%20brown%20tones%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a5&orientation=landscape",
  a6: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20globe%20with%20handshakes%20and%20flags%20around%20it%2C%20international%20events%20and%20diplomacy%20theme%2C%20warm%20orange%20amber%20cream%20palette%2C%20flat%20vector%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-a6&orientation=landscape",
  m1: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20dark%20horse%20horse%20racing%20forward%20with%20speed%20lines%20and%20stars%2C%20unexpected%20winner%20theme%2C%20warm%20orange%20and%20gold%20tones%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m1&orientation=landscape",
  m2: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20microphone%20with%20sound%20waves%20and%20live%20broadcast%20icons%2C%20music%20and%20variety%20show%20gossip%20theme%2C%20peach%20coral%20and%20cream%20palette%2C%20flat%20vector%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m2&orientation=landscape",
  m3: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20detective%20with%20magnifying%20glass%20and%20folder%20papers%20over%20a%20warm%20orange%20desk%2C%20truth%20and%20investigation%20theme%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m3&orientation=landscape",
  m4: "https://readdy.ai/api/search-image?query=Illustration%20of%20sports%20figures%20and%20running%20track%20with%20medals%20and%20warm%20flame%20motifs%2C%20sports%20highlights%20theme%2C%20orange%20red%20cream%20palette%2C%20flat%20vector%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m4&orientation=landscape",
  m5: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20phones%20showing%20social%20media%20feeds%20with%20shopping%20carts%20and%20parcels%2C%20ecommerce%20and%20livestream%20selling%20theme%2C%20warm%20orange%20amber%20palette%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m5&orientation=landscape",
  m6: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20family%20home%20with%20hearts%20and%20document%20scrolls%2C%20family%20and%20legal%20gossip%20theme%2C%20warm%20coral%20and%20cream%20palette%2C%20flat%20vector%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-m6&orientation=landscape",
  t1: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20crowd%20watching%20a%20bright%20stage%20show%20with%20confetti%20and%20streamers%2C%20variety%20gala%20trend%20theme%2C%20warm%20gold%20orange%20palette%2C%20modern%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-t1&orientation=landscape",
  t2: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20neon%20sign%20glowing%20over%20a%20night%20street%20with%20silhouette%20crowd%20gathering%2C%20late%20night%20controversy%20theme%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20flat%20vector%20editorial%20style%2C%20no%20text&width=1200&height=800&seq=chigua-cover-t2&orientation=landscape",
};

export const hero = IMG.hero;

export const categories = [
  { key: "ent", name: "文娱风云", desc: "影视、综艺与舞台的名场面盘点" },
  { key: "biz", name: "商业大瓜", desc: "公司、品牌与创业圈的起落故事" },
  { key: "sport", name: "竞技名场面", desc: "赛场内外的高光与风波" },
  { key: "social", name: "社会热点", desc: "公共议题与大众情绪的交汇点" },
];

export const allArticles: ArticleItem[] = [
  {
    id: "annual-chiguawang-2025",
    group: "annual",
    category: "文娱风云",
    rank: 1,
    title: "2025 年度瓜王盘点：谁承包了你这一年的瓜田",
    excerpt: "从开年第一爆到年末压轴，我们用热度与后劲双维度，选出本年度最让人上头的年度瓜王，带你一键补完全程。",
    date: "2026-01-06",
    month: "一月",
    heat: "1280万",
    tags: ["年度瓜王", "文娱风云", "年度盘点"],
    cover: IMG.a1,
    standouts: ["话题持续周期最长", "全网讨论量断层第一", "衍生梗出圈次数最多"],
    content: [
      "每年开年都有人问：去年到底谁才是真正的瓜王？热度最高的未必是后劲最大的，真正配得上年度瓜王四个字的，往往是那种能反复发酵、让网友愿意追上一整年的长线话题。",
      "我们综合了搜索热度、社交平台讨论量、内容二创数量与话题生命周期四个维度，把 2025 年最具代表性的热点事件做了多轮交叉评分，最终这份榜单把第一名留给了一位真正意义上'从年头火到年尾'的话题主角。",
      "值得注意的现象是，如今的年度瓜王早已不是单纯靠爆料取胜。传播节奏、情绪切口、以及当事人后续的每一次回应，都决定了话题能走多远。真正会'做瓜'的，是把悬念留得够久的那个。",
      "如果你还停留在'好像刷到过但没细看'的阶段，那这份年度盘点就是为你准备的——从起因、发酵到结局，一次给你讲明白，吃瓜不断档。",
    ],
  },
  {
    id: "annual-toudan-duijue",
    group: "annual",
    category: "文娱风云",
    rank: 2,
    title: "年度最佳对峙名场面：2025 年里让人反复回味的正面交锋",
    excerpt: "隔空喊话、正面回应、含沙射影……我们把 2025 年里最精彩的几场'瓜田对决'按戏剧性排了个名。",
    date: "2026-01-04",
    month: "一月",
    heat: "980万",
    tags: ["年度盘点", "名场面", "文娱风云"],
    cover: IMG.a2,
    standouts: ["回应时间线最紧凑", "金句传播最广", "反转次数最多"],
    content: [
      "吃瓜群众最爱的，从来不只是结果，而是过程里那一次次让人拍案的对峙。2025 年并不缺少这样的名场面，有些隔空喊话甚至让吃瓜变成了连续剧。",
      "这一季的对峙呈现出新特点：越来越多当事人选择正面回应而不是冷处理，一来一回的节奏明显加快，也让不少本来可能石沉大海的话题，硬生生被聊出了第二、第三季。",
      "榜单按戏剧张力与传播广度综合排序，为你还原每一场交锋的来龙去脉，看看谁真正把话说到了点子上，谁又在一来一回中逐渐失了分寸。",
    ],
  },
  {
    id: "annual-fuhuo-fenghuang",
    group: "annual",
    category: "商业大瓜",
    rank: 3,
    title: "年度翻身剧本：2025 年那些低谷逆袭的商业主角",
    excerpt: "被唱衰一整年却迎来反转，我们用数据复盘了几个年度最佳'逆袭剧本'，看商业世界里如何靠口碑与耐心扳回一局。",
    date: "2025-12-28",
    month: "十二月",
    heat: "760万",
    tags: ["年度盘点", "商业大瓜", "逆袭"],
    cover: IMG.a3,
    content: [
      "商业世界的瓜，往往比文娱更有后劲。2025 年有一批曾被打上'凉凉'标签的品牌与创业者，用一整年的动作悄悄改写了叙事。",
      "我们复盘了公开的营收、舆情与产品数据，找出三个最典型的'翻身剧本'。它们的共同点惊人地一致：先承认问题、再拿出真改进、最后用时间换回信任。",
      "对吃瓜的人来说，看一个被唱衰的对象如何步步为营、最终让舆论反转，比单纯的踩雷爽点更耐人寻味，也更有参考价值。",
    ],
  },
  {
    id: "annual-shehui-fengxiang",
    group: "annual",
    category: "社会热点",
    rank: 4,
    title: "年度社会议题盘点：2025 年那些被大众反复讨论的公共话题",
    excerpt: "从校园到职场、从线上到线下，哪些议题真正撬动了大众情绪？我们用一份年度时间线，梳理这一年公共讨论的脉络。",
    date: "2025-12-20",
    month: "十二月",
    heat: "720万",
    tags: ["年度盘点", "社会热点"],
    cover: IMG.a6,
    content: [
      "回顾 2025，社交平台的公共讨论呈现出明显的'下沉'与'共情'趋势：越来越多普通人的真实处境被推上热搜，议题也从猎奇转向关切。",
      "这一年的公共话题讨论里，情绪共鸣成为最强传播引擎。一件具体的小事，往往能牵出一整类人的共同经历，进而形成持续数日的讨论场。",
      "我们把这些话题按关注度与影响面整理成年度脉络，帮助你理解这一年中国网民真正在关心什么，也看见那些被看见的普通人。",
    ],
  },
  {
    id: "annual-jingji-nvshen",
    group: "annual",
    category: "竞技名场面",
    rank: 5,
    title: "年度竞技名场面：2025 体育大年里的高光与争议时刻",
    excerpt: "奖牌、纪录、争议与泪水，2025 作为体育大年贡献了太多值得被记住的瞬间，我们为它们一一正名。",
    date: "2025-12-16",
    month: "十二月",
    heat: "680万",
    tags: ["年度盘点", "竞技名场面", "体育"],
    cover: IMG.a5,
    content: [
      "体育赛场从来都是瓜田的高产区。2025 年的竞技名场面里，有逆转夺冠的热血，也有判罚与场外风波带来的争论。",
      "我们对全年大型赛事的焦点时刻做了回顾，既有让人起鸡皮疙瘩的绝杀瞬间，也复盘了几起引发全网热议的规则争议。",
      "无论你是资深球迷还是只看热闹的吃瓜人，这份盘点都能让你在两分钟内补完这一年的体坛名场面。",
    ],
  },
  {
    id: "monthly-darwin-kongque",
    group: "monthly",
    category: "文娱风云",
    rank: 1,
    title: "本月黑马：一部低成本剧如何靠口碑杀出重围",
    excerpt: "没有大牌、没有铺天盖地的宣发，这部本月黑马剧却用扎实内容撬动了自来水式传播，我们拆解了它的走红路径。",
    date: "2026-02-02",
    month: "二月",
    heat: "640万",
    tags: ["月度黑马", "文娱风云", "月度总结"],
    cover: IMG.m1,
    content: [
      "每个月的瓜田里，最让人惊喜的往往是那些一开始没人在意的'小透明'。本月黑马非这部低成本剧莫属，它几乎零宣发上线，却在两周内靠口碑实现了热度反超。",
      "它的走红路径非常典型：先靠前几集的口碑在核心剧粉中发酵，随后被大量'自来水'安利出圈，最后连原本不看的网友也忍不住入坑。",
      "我们复盘了这部剧从上线到霸榜的完整时间线，也总结了内容出圈背后真正起作用的几个要素。",
    ],
  },
  {
    id: "monthly-zongyi-xianchang",
    group: "monthly",
    category: "文娱风云",
    rank: 2,
    title: "二月综艺观察：老牌节目的回春与新面孔的突围",
    excerpt: "二月综艺市场冰火两重天，有人靠情怀回春，有人靠新鲜感突围，我们整理了本月综艺圈的几件大事。",
    date: "2026-02-12",
    month: "二月",
    heat: "580万",
    tags: ["月度总结", "综艺", "文娱风云"],
    cover: IMG.m2,
    content: [
      "开年综艺大战向来是瓜田重灾区。本月既有回归的国民级老牌综艺，也不乏大胆启用新人的黑马节目。",
      "老牌综艺回春的关键在于'旧瓶装新酒'，新面孔突围的秘诀则是差异化的表达方式。两种路径在同月同台竞技，给观众提供了截然不同的看瓜体验。",
      "这份月度综艺观察，帮你快速锁定本月真正值得追的节目与值得关注的人。",
    ],
  },
  {
    id: "monthly-zhenxiang-diaocha",
    group: "monthly",
    category: "社会热点",
    rank: 3,
    title: "本月反转大戏：当'实锤'也需要被重新审视",
    excerpt: "这个月最具戏剧性的不是爆料本身，而是一次彻头彻尾的反转。当所有人都以为尘埃落定时，真相才刚刚开始。",
    date: "2026-02-09",
    month: "二月",
    heat: "560万",
    tags: ["月度总结", "反转", "社会热点"],
    cover: IMG.m3,
    content: [
      "本月最让人上头的不是一条热搜，而是一整条充满反转的瓜。起初证据看似板上钉钉，舆论几乎一边倒，但后续更多细节浮出水面后，剧情彻底翻篇。",
      "这起案例再次提醒我们：在完整信息拼齐之前，过早下结论往往是最容易翻车的吃瓜姿势。我们完整梳理了这起反转事件的时间线，还原真相如何一步步被拼出。",
      "对吃瓜人来说，学会'让子弹再飞一会儿'，往往比第一时间站队更能看清全貌。",
    ],
  },
  {
    id: "monthly-tiyu-jingji",
    group: "monthly",
    category: "竞技名场面",
    rank: 4,
    title: "本月体坛：一场引发全网争论的判罚与它的后续",
    excerpt: "本月体坛最大瓜来自一次争议判罚，从赛场到评论区，关于公平与规则的讨论持续了整个月。",
    date: "2026-02-05",
    month: "二月",
    heat: "510万",
    tags: ["月度总结", "竞技名场面"],
    cover: IMG.m4,
    content: [
      "一场关键比赛的争议判罚，让本月体坛瓜田彻底沸腾。支持与反对的声音在评论区激烈交锋，甚至延伸到规则与判罚标准的专业讨论。",
      "我们复盘了判罚发生瞬间的细节与各方回应，也整理了裁判规则中真正存在争议的部分，帮助你更客观地看懂这起风波。",
      "无论结果如何，这场讨论本身已经把体育规则科普推向了前所未有的热度。",
    ],
  },
  {
    id: "monthly-dianshang-zhubo",
    group: "monthly",
    category: "商业大瓜",
    rank: 5,
    title: "本月商业观察：直播带货圈的洗牌与头部主播的危机",
    excerpt: "本月商业圈最劲爆的瓜来自直播带货：头部主播接连翻车，中小主播趁势上位，行业正在经历一轮深度洗牌。",
    date: "2026-02-15",
    month: "二月",
    heat: "490万",
    tags: ["月度总结", "商业大瓜"],
    cover: IMG.m5,
    content: [
      "直播带货圈这个月几乎天天上热搜。头部主播因品控与言论问题接连陷入舆论危机，而一批此前默默无闻的中腰部主播，则抓住机会实现了粉丝与销量的双重跃升。",
      "我们跟踪了本月几起最具代表性的翻车与上位案例，也分析了平台规则调整对行业格局的深层影响。",
      "当流量红利见顶，真正决定主播能走多远的，正在从'嗓门大小'转向'品控与信任'。",
    ],
  },
  {
    id: "monthly-jiating-falv",
    group: "monthly",
    category: "社会热点",
    rank: 6,
    title: "本月家事大瓜：一场持续发酵的家庭纠纷说明了什么",
    excerpt: "本月一桩家庭纠纷引发的讨论，从家长里短一路聊到了法律与边界，我们梳理了这起事件的来龙去脉。",
    date: "2026-01-28",
    month: "一月",
    heat: "460万",
    tags: ["月度总结", "社会热点"],
    cover: IMG.m6,
    content: [
      "本月最出圈的瓜，竟然来自一场家庭内部纠纷。起初只是网友围观吐槽，但随着更多信息曝光，讨论迅速升级为关于亲情边界、财产与法律意识的严肃议题。",
      "这起事件折射出当代人在亲密关系与个人权益之间寻找平衡的真实困境，也因此获得了远超娱乐八卦的讨论深度。",
      "我们完整梳理了事件脉络，也邀请了法律视角的分析，帮助大家在吃瓜之余获得更理性的参考。",
    ],
  },
  {
    id: "annual-2025-variety-gala",
    group: "annual",
    category: "文娱风云",
    rank: 6,
    title: "年度综艺金句盘点：2025 那些出圈的综艺名场面",
    excerpt: "一句金句能火一年，一个名场面能养出一整季的讨论。我们盘点了 2025 年最出圈的综艺金句与其背后的名场面。",
    date: "2025-12-24",
    month: "十二月",
    heat: "440万",
    tags: ["年度盘点", "综艺", "文娱风云"],
    cover: IMG.t1,
    content: [
      "综艺节目的寿命，往往藏在几句能让人反复回味的金句里。2025 年全年，无数名场面在社交平台被反复剪辑、转译与玩梗，成为持续一整年的内容富矿。",
      "我们按传播广度与后劲，选出年度十大综艺金句。每一句背后，都站着一个让人印象深刻的综艺时刻与一场真实的情绪交锋。",
      "这份盘点既是对过去一年综艺内容的回顾，也是对新一年'出圈方法论'的一次小小的预习。",
    ],
  },
];

export const homeFaqs = [
  {
    q: "什么是「年度瓜王」？它是怎么选出来的？",
    a: "「年度瓜王」是吃瓜榜单在每年年初，综合全年热点事件的话题热度、传播周期、二创数量与情绪后劲，通过多维度加权评分选出的年度代表性热点。它不一定是最吵的那一个，而是最能让大众追完整年、反复回味的那一个。",
  },
  {
    q: "「月度黑马」与「月度总结」有什么区别？",
    a: "「月度总结」是当月最具热度与话题性热点的完整复盘；而「月度黑马」是其中专门用来标记那些开播或爆发初期关注度不高、却靠内容与口碑实现逆袭的'小透明'型热点，帮你不错过任何潜力股。",
  },
  {
    q: "榜单多久更新一次？",
    a: "吃瓜榜单会在每月初发布上一月的「月度总结」，每年初发布「年度盘点」与「年度瓜王」。对于爆发性极强、迅速霸榜的热点，我们也会在首页以'实时热点榜'的形式即时补充，尽量做到不断档。",
  },
  {
    q: "你们的内容来源可靠吗？",
    a: "我们坚持'先溯源、后盘点'的原则。每一期盘点都会标注信息来源，优先采用多方交叉验证后的一致口径；对尚处于争议中、证据不完整的话题，我们会明确提示'仍在发酵'，而不是抢先下结论，力求客观理性吃瓜。",
  },
  {
    q: "我可以投稿或投稿线索吗？",
    a: "当然可以。如果你有希望我们盘点的热点线索，欢迎通过联系我们页面的表单投稿。我们会优先评估话题的公共价值与可信度，审核通过后纳入后续的月度或年度盘点选题库。",
  },
];

export const categoriesMeta: Record<
  string,
  { key: string; name: string; icon: string; count: number; tone: "primary" | "accent" | "secondary" }
> = {
  "文娱风云": { key: "ent", name: "文娱风云", icon: "ri-mic-line", count: 26, tone: "primary" },
  "商业大瓜": { key: "biz", name: "商业大瓜", icon: "ri-briefcase-4-line", count: 18, tone: "accent" },
  "竞技名场面": { key: "sport", name: "竞技名场面", icon: "ri-trophy-line", count: 15, tone: "secondary" },
  "社会热点": { key: "social", name: "社会热点", icon: "ri-earth-line", count: 21, tone: "primary" },
};